/**
 * /watch — the unattended broadcast view.
 *
 * Renders the live throne hall in broadcast mode: spectator join (no avatar, no
 * mic), the auto-director camera, and the broadcast HUD — no player rig or
 * player-facing chrome. This is the surface OBS captures for manned narration
 * and the headless auto-stream box loads for 24/7 coverage. Round selection
 * still flows through the usual `?round=` / localStorage path; auto-following
 * the keeper's rolling rounds is the next slice.
 */
import { LobbyScene } from "../scene/Lobby";

export function WatchPage(): JSX.Element {
  return <LobbyScene broadcast />;
}

export default WatchPage;
